import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.5 2.25C15.5 1.83579 15.8358 1.5 16.25 1.5H21.75C22.1642 1.5 22.5 1.83579 22.5 2.25V7.75C22.5 8.16421 22.1642 8.5 21.75 8.5C21.3358 8.5 21 8.16421 21 7.75V4.06066L14.7803 10.2803C14.4874 10.5732 14.0126 10.5732 13.7197 10.2803C13.4268 9.98743 13.4268 9.51256 13.7197 9.21967L19.9393 3H16.25C15.8358 3 15.5 2.66421 15.5 2.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.5 4.25C2.5 3.2835 3.2835 2.5 4.25 2.5H12.75C13.1642 2.5 13.5 2.83579 13.5 3.25C13.5 3.66421 13.1642 4 12.75 4H4.25C4.11193 4 4 4.11193 4 4.25V19.75C4 19.8881 4.11193 20 4.25 20H19.75C19.8881 20 20 19.8881 20 19.75V11.25C20 10.8358 20.3358 10.5 20.75 10.5C21.1642 10.5 21.5 10.8358 21.5 11.25V19.75C21.5 20.7165 20.7165 21.5 19.75 21.5H4.25C3.2835 21.5 2.5 20.7165 2.5 19.75V4.25Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgExport;
